export const env = {
  apiBaseUrl: 'https://cab-gateway.signitydemo.in/api/',
  imageUrl: 'https://d1scs487cjcjih.cloudfront.net/',

  firebaseConfig: {
    apiKey: 'AIzaSyC3qi9FzxNeQf43fhi8GmNPKBTPOcKSJw4',
    authDomain: 'rhpuat.firebaseapp.com',
    projectId: 'rhpuat',
    storageBucket: 'rhpuat.appspot.com',
    messagingSenderId: '675300811932',
    appId: '1:675300811932:web:5f3b7ceade89f0dfd67959',
    measurementId: 'G-SRP39MEY72'
  }
}
